import React from 'react'
import style from  "../TermAndPolicy/TermAndPolicy.module.css"
import SlideUpWrapper from '../../components/Transitions/SlideUpWrapper'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { updateUser } from '../../Utils/Redux/UserSlice'
import Header from '../../components/DashBoard/Header'
const TermAndCondition = () => {

    const dispatch=useDispatch()
    const User=useSelector(state=>state.User)
    const navigate=useNavigate();
    const handleNavigate=(e)=>{

        e.preventDefault()
        dispatch(updateUser({
            user_name:User.email
        }))        
        navigate("/dashboard")
    }
    
    const representation=[
        {
        points:"You have a specific and permissible purpose to access this data."
        },
        {
        points:"You have obtained prior written authorization from the Individual to verify his/her details for employment purpose. You will maintain and produce the written authorization of the individual in case of any dispute on verification via AuthNumber."},
        {points:"You have maintained and will produce separate authorizations of the same individual in more than one employer verifications conducted on AuthNumber."},
        {points:"Service is provided to you solely on condition that the data provided will be used only for the specific purpose for which the consent is received from the individual. Any usage of data for any other purpose is prohibited."}

    ]
  return (
    <>
    <Header/>
    <SlideUpWrapper>
        <div className={style.TermAndPolicy}>
            <div className={style.authnumberParent}>
                                            <img className={style.subtractIcon} loading="eager" alt="" src="/Header_icon.svg" />

                                            <img className={style.authnumberIcon} loading="eager" alt="" src="/authnumber_1.svg" />
                                        </div>
            <div className={style.TermsandPolicyBox}>
                <div>
                    <h1 className={style.TermAndPolicyHeading}>Term And Conditions</h1>
                </div>
                <div>

                    <div style={{textAlign:"center"}}><h3 className={style.heading}>AuthBridge Research Services Private Limited</h3></div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Terms</h2>
                    </div>

                    <div>

                        <p className={style.paragraph}>By accessing the website at https://app.authnumber.com/login, you agree to be bound by these terms of service, all applicable laws and regulations, and agree that you are responsible for compliance with all applicable local laws. If you do not agree with any of these terms, you are prohibited from using or accessing this site. The information on this website is protected by the applicable copyright and trademark law.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Use License</h2>
                    </div>

                    <div>
                        <p className={style.paragraph}>a. Permission is granted to temporarily download one copy of the material (information or software) on AuthBridge Research Services Private Limited's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:</p>
                        <ul>
                            <li>modify or copy the materials;</li>
                            <li>use the materials for any commercial purpose, or for any public display (commercial or non-commercial)</li>
                            <li>attempt to decompile or reverse engineer any software contained on AuthBridge Research Services Private Limited's website</li>
                            <li>remove any copyright or other proprietary notations from the materials; or</li>
                            <li>Transfer the materials to another person or "mirror" the materials on any other server.</li>
                        </ul>

                        <p className={style.paragraph}>b. This license shall automatically terminate if you violate any of these restrictions and may be terminated by AuthBridge Research Services Private Limited at any time. Upon terminating your viewing of these materials or upon the termination of this license, you must destroy any downloaded materials in your possession whether in electronic or printed format.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Disclaimer</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>a. The materials on Authnumber Website (from AuthBridge Research Services Private Limited) are provided on an 'as is' basis. AuthBridge Research Services Private Limited makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including, without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.</p>
                        <p className={style.paragraph}>b. Further, AuthBridge Research Services Private Limited does not warrant or make any representations concerning the accuracy, likely results, or reliability of the use of the materials on its website or otherwise relating to such materials or on any sites linked to this site.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Limitations</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>
                        In no event shall AuthBridge Research Services Private Limited or its suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on AuthBridge Research Services Private Limited's website, even if AuthBridge Research Services Private Limited or a AuthBridge Research Services Private Limited authorized representative has been notified orally or in writing of the possibility of such damage. Because some jurisdictions do not allow limitations on implied warranties, or limitations of liability for consequential or incidental damages, these limitations may not apply to you.
                        </p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Accuracy of materials</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>The materials appearing on AuthBridge Research Services Private Limited's website could include technical, typographical, or photographic errors. AuthBridge Research Services Private Limited does not warrant that any of the materials on its website are accurate, complete or current. AuthBridge Research Services Private Limited may make changes to the materials contained on its website at any time without notice. However AuthBridge Research Services Private Limited does not make any commitment to update the materials.</p>
                    </div>
                </div>
                <div>
                    <div>
                        <h2 className={style.heading}>Links</h2>
                    </div>
                    <div>
                        <p className={style.paragraph}>AuthBridge Research Services Private Limited has not reviewed all of the sites linked to its website and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by AuthBridge Research Services Private Limited of the site. Use of any such linked website is at the user's own risk.</p>
                    </div>
                </div>
                <div>
                <div>
                    <h2 className={style.heading}>
                    Modifications
                    </h2>
                </div>
                <div>
                    <p className={style.paragraph}>AuthBridge Research Services Private Limited may revise these terms of service for its website at any time without notice. By using this website you are agreeing to be bound by the then current version of these terms of service.</p>
                </div>
                </div>
                <div>
                <div>
                    <h2 className={style.heading}>Governing Law</h2>
                </div>

                <div>
                    <p className={style.paragraph}>These terms and conditions are governed by and construed in accordance with the laws of Gurgaon, Haryana and you irrevocably submit to the exclusive jurisdiction of the courts in that State or location.</p>
                </div>
                </div>
            </div>
            <div>
                <div>
                    <h3>Authnumber is an expert offering from Authbridge</h3>
                </div>
                </div>
        </div>
    </SlideUpWrapper>
    </>
  )
}

export default TermAndCondition